import _ from 'lodash';
import moment from 'moment';
import { StateConfig } from '../../types';
import { filterInputsWithValues } from '../details/queries';

export const getAuditDisplayDate = (timestampInMs) => {
  if (_.isNil(timestampInMs)) {
    return '';
  }

  const date = moment(Number(timestampInMs));
  if (!date.isValid()) {
    return '';
  }

  return date.format('ddd, MMM D, YYYY');
};

export const getAuditDisplayTime = (timestampInMs) => {
  if (_.isNil(timestampInMs)) {
    return '';
  }

  const date = moment(Number(timestampInMs));
  if (!date.isValid()) {
    return '';
  }

  return date.format('hh:mm A');
};

export const getHistoryTitle = ({
  history,
  correspondingEvent,
  correspondingState,
  states = [] as StateConfig[],
}) => {
  if (history?.fromState && history?.toState) {
    const correspondingFromState = states.find(
      (state) => state?.id === history?.fromState,
    );

    const correspondingToState = states.find(
      (state) => state?.id === history?.toState,
    );

    return `${correspondingFromState?.name} -> ${correspondingToState?.name}`;
  }

  return correspondingEvent?.actionName || correspondingState?.name;
};

/**
 *
 * @param props
 * @param audits
 * @param revyreConfig
 * @returns AuditHistory
 *
 * AuditHistory: Array<{
 *      date: any in format DD-MM-YYYY;
 *      time: any;
 *      inputs: any;
 *      title: string;
 * }>
 */
export const getTransformedHistories = (
  props,
  historyList,
  revyreConfig,
  audit,
) => {
  if (props.revyre) {
    const { workflowType, domainType } = props;
    const events = revyreConfig?.[workflowType || domainType]?.events || [];
    const states = revyreConfig?.[workflowType || domainType]?.states || [];
    const histories = (historyList || []).map((history) => {
      const correspondingEvent = events.find(
        (event) => event?.allowedAction === history?.eventId,
      );
      const correspondingState = states.find(
        (state) => state?.id === history?.toState,
      );
      const eventPayloadWorkflowType = history?.eventPayload?.workflowType;
      const eventPayloadOutcomeGroup = history?.eventPayload?.outcomeGroup;
      const eventPayloadWorkflowEvents =
        revyreConfig?.[eventPayloadWorkflowType]?.events || [];

      const correspondingWorkflowEvent = eventPayloadWorkflowEvents.find(
        (event) => event?.allowedAction === eventPayloadOutcomeGroup,
      );

      const {
        detailInputs: workflowEventDetailInputs = [],
        inputs: workflowEventInputs = [],
        groups: workflowEventGroups = [],
      } = correspondingWorkflowEvent?.config || {};
      const workflowAuditInputs = workflowEventDetailInputs.length
        ? workflowEventDetailInputs
        : workflowEventInputs;
      const auditInputs = [
        ...(correspondingEvent?.config?.detailInputs || []),
        ...workflowAuditInputs,
      ];
      const auditGroups = [
        ...(correspondingEvent?.config?.groups || []),
        ...workflowEventGroups,
      ];
      const auditFormValues = {};
      const auditInputsWithValues = auditInputs.map((input) => {
        const value = history?.eventPayload?.[input.code];
        auditFormValues[input.code] = { value };

        return {
          ...input,
          value,
        };
      });
      const eventActionNameByEventId = events.find(
        (event) => event?.allowedAction === history?.eventId,
      )?.actionName;

      return {
        inputs: audit
          ? filterInputsWithValues(auditInputsWithValues, auditFormValues)
          : [],
        grouping: audit ? auditGroups : [],
        date: getAuditDisplayDate(history?.eventTime),
        time: getAuditDisplayTime(history?.eventTime),
        title: getHistoryTitle({
          history,
          correspondingEvent,
          correspondingState,
          states,
        }),
        subTitle: eventActionNameByEventId,
        type: 'vymo',
      };
    });
    return histories;
  }
  return [];
};
